export default __webpack_public_path__ + "static/media/sqlLogo.794cd99c.svg";